export const KPI_ROW_HEIGHT = 30;
export const KPI_EXTENDED_ROW_HEIGHT = 62;
export const KPI_GROUP_ROW_HEIGHT = 30;
export const KPI_ROW_MARGIN_BOTTOM = 16;
